import clsx from "clsx";

export const LandingImageBar = ({ data }) => {
  return (
    <section className="section-layout">
      {data?.fields?.image && (
        <img
          src={data?.fields?.image}
          alt={data?.fields?.image_alt}
          className={clsx(
            "LandingImageBar",
            data?.fields?.remove_border_radius === true && "no-radius",
          )}
        />
      )}
    </section>
  );
};
